import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { getUserToken } from "utils/getToken";

export const ApiLojaBaseURL = process.env.REACT_APP_API_LOJA_URL || "";

export const ApiLojaInstance = axios.create({
  baseURL: ApiLojaBaseURL,
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    Authorization: getUserToken(),
  },
  timeout: 75000,
});

type Headers = {
  [key: string]: string;
};

const getAuthHeaders = (headers?: Headers) => ({
  ...headers,
  Authorization: localStorage.getItem("UserToken"),
});

export async function ApiLojaGet<ResponseDataType = any>(
  url: string,
  config?: AxiosRequestConfig
): Promise<AxiosResponse<ResponseDataType>> {
  return ApiLojaInstance.get<ResponseDataType>(url, {
    ...config,
    headers: getAuthHeaders(config?.headers as Headers | undefined),
  });
}

export async function ApiLojaPost<ResponseDataType = any>(
  url: string,
  data?: unknown,
  config?: AxiosRequestConfig
): Promise<AxiosResponse<ResponseDataType>> {
  return ApiLojaInstance.post<ResponseDataType>(url, data, {
    ...config,
    headers: getAuthHeaders(config?.headers as Headers | undefined),
  });
}
